import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGlobe, faPlay } from '@fortawesome/free-solid-svg-icons';
//import { useRecoilValue } from 'recoil';
import { useState, memo } from 'react'

import { VideoPlayer } from '../../components';
import { MovieCategory, TvCategory } from '../../constants';
//import { atomOfContentData } from '../../global'
//import { formatImagePath } from '../../utils';
import { publicUrlStr } from '../../utils';
import * as S from './style';

// Swiper related stuff
import { Swiper, SwiperSlide } from 'swiper/react';
// Import Swiper modules as default exports from their paths
// Correct: Named imports from 'swiper'
import { Navigation, Pagination, Autoplay, EffectFade } from 'swiper/modules';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/effect-fade';

interface IBanner {
  kind: MovieCategory | TvCategory;
}

function Banner({ kind }: IBanner) {
  // console.log('banner')

  const [showPlayer, setShowPlayer] = useState(false);

  //Banner Stuff(Text)
  const title_text = 'Highest GDI'
  const description_text = 'Leading global cultural innovation thorugh AI-Generated Media'

  const slides = [
    {
      id: 1,
      title: title_text,
      description: description_text,
      imageUrl: '/bannerImg/banner1.png',
    },
    {
      id: 2,
      title: title_text,
      description: description_text,
      imageUrl: '/bannerImg/banner2.png',
    },
    {
      id: 3,
      title: title_text,
      description: description_text,
      imageUrl: '/bannerImg/banner3.png',
    },
    {
      id: 4,
      title: title_text,
      description: description_text,
      imageUrl: '/bannerImg/banner4.png',
    },
  ];

  return (
    <>
      <S.GlobalStyle />
        <S.Banner> {/*Initial BG photo for fallback (Removed)*/}
          <Swiper
            modules={[Navigation, Pagination, Autoplay, EffectFade]}
            spaceBetween={0}
            slidesPerView={1}
            navigation //automatically sets the navigation buttons
            pagination={{ clickable: true }}
            autoplay={{ delay: 5000, disableOnInteraction: false }}
            effect="fade"
            fadeEffect={{ crossFade: true }}  // crossFade for simultaneous
            loop
            className="swiper-container"
          >
            {slides.map((slide) => (
              <SwiperSlide key={slide.id}>
                <div className="slide" style={{backgroundImage: `url(${publicUrlStr()}/${slide.imageUrl})`}} /*Set Background Image*/>  
                  <S.Wrapper>
                    <S.Title>{slide.title}</S.Title>
                    <S.Overview>{slide.description}</S.Overview>
                    <S.ButtonWrapper>
                      <S.BannerButton onClick={() => setShowPlayer(true)}>
                        <FontAwesomeIcon icon={faPlay} />
                        <span>Play</span>
                      </S.BannerButton>
                      <S.BannerButton onClick={() => {window.open("https://gdi.re.kr/main", "경북연구원");}} //<S.BannerButton onClick={showDetail}
                      >
                        <FontAwesomeIcon icon={faGlobe} />
                        <span>Visit Website</span>
                      </S.BannerButton>
                    </S.ButtonWrapper>
                  </S.Wrapper>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </S.Banner>
      
      {showPlayer && (<VideoPlayer isYt onClose={() => setShowPlayer(false)}/>)}
    </>
  )
}

export default memo(Banner);
